<template>
    <main>
        <div class="tw-container">
            <div>
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" >
                    Thank you message
                </FormSuccess>
            </div>
        </div>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
